import { ScanSearch, TrendingUp, Compass, Bookmark, ListChecks, Package, ReceiptText, LineChart } from "lucide-react";
import { useSearchParams } from "react-router-dom";

export const STORAGE_KEYS = {
  sidebarCollapsed: "ezisell.ui.sidebar-collapsed.v1",
  pinnedShortcuts: "ezisell.ui.pinned-shortcuts.v1",
  recentPages: "ezisell.ui.recent-pages.v1",
  selectedWorkspace: "ezisell.ui.workspace.v1",
};

export function loadJSON(key, fallback) {
  try { const v = localStorage.getItem(key); return v === null ? fallback : JSON.parse(v); }
  catch { return fallback; }
}
export function saveJSON(key, val) {
  try { localStorage.setItem(key, JSON.stringify(val)); } catch { /* ignore */ }
}

// Real destinations with their own icons (never a clock icon).
export const SHORTCUT_DESTINATIONS = [
  { id: "analyzer", to: "/app/analyzer", label: "Product Analyzer", icon: ScanSearch },
  { id: "top", to: "/app/research/top", label: "Top-Selling Products", icon: TrendingUp },
  { id: "finder", to: "/app/research/finder", label: "Product Finder", icon: Compass },
  { id: "leads", to: "/app/leads", label: "Saved Leads", icon: Bookmark },
  { id: "purchase", to: "/app/inventory/po", label: "Purchase Lists", icon: ListChecks },
  { id: "inventory", to: "/app/inventory", label: "Inventory", icon: Package },
  { id: "receipts", to: "/app/receipts/scan", label: "Receipt Scanner", icon: ReceiptText },
  { id: "profit", to: "/app/sales/profit", label: "Profit Analytics", icon: LineChart },
];
export const DESTINATION_BY_ID = Object.fromEntries(SHORTCUT_DESTINATIONS.map((d) => [d.id, d]));
export const DESTINATION_BY_PATH = Object.fromEntries(SHORTCUT_DESTINATIONS.map((d) => [d.to, d]));
export const DEFAULT_PINNED = ["analyzer", "top", "leads", "inventory", "receipts"];
export const MAX_SHORTCUTS = 5;

// URL-driven inspectable UI states: ?uiState=loading|empty|error|low-confidence
export function useUiState() {
  const [params] = useSearchParams();
  return params.get("uiState") || "ready";
}
